var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBackwardArrow = function SvgIconBackwardArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_backward_arrow_svg__a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h24v24H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_backward_arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M14.5 17.654 8.847 12 14.5 6.346 15.554 7.4l-4.6 4.6 4.6 4.6z"
  }))));
};
export default SvgIconBackwardArrow;